export enum AlertStatus {
    info = 'info',
    warning = 'warning',
    strongWarning = 'strongWarning',
    error = 'error',
    success = 'success',
}

export interface Alert {
    id: string;
    global: boolean;
    body: string;
    status: AlertStatus;
    crashAlert?: boolean;
    onClose?: () => void | Promise<void>;
}
